export default "__VITE_ASSET__D$28GBpy__"